import { render, staticRenderFns } from "./SingleSwitchSlim.vue?vue&type=template&id=f836b53a"
import script from "./SingleSwitchSlim.vue?vue&type=script&lang=js"
export * from "./SingleSwitchSlim.vue?vue&type=script&lang=js"
import style0 from "./SingleSwitchSlim.vue?vue&type=style&index=0&id=f836b53a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports